import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


const au2Api = createApi({
    reducerPath: "boundary/au2",
    baseQuery: axiosBaseQuery,
    tagTypes: ["au2List"],
    endpoints: (builder) =>({
        au2FindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['au2List'],
            query: (query = '') => ({
                url: "boundary/au2/" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        au2Create: builder.mutation({
            invalidatesTags: ['au2List'],
            query: (data)=>({url: "boundary/au2/", method: "POST", data})
        }),
        au2Update: builder.mutation({
            invalidatesTags: ['au2List'],
            query: (data)=>({url: "/boundary/au2/"+data.id, method: "PUT", data})
        }),
        // console.log(data);
        
        au2Delete: builder.mutation({
            invalidatesTags: ['au2List'],
            query: (id)=>({url: "/boundary/au2/"+id, method: "DELETE"})
        }),
    })
})

export const { useAu2FindAllQuery, useAu2CreateMutation, useAu2UpdateMutation, useAu2DeleteMutation } = au2Api;
export {au2Api};
